// SubscriptionFlowController
app.controller('SubscriptionFlowController', ['$scope', '$routeParams', 'sessionService', 'WdHttpService', 'config', '$sce', 'analyticsService', '$timeout', '$window',
    function ($scope, $routeParams, sessionService, WdHttpService, config, $sce, analyticsService, $timeout, $window) {

        // Init 
        $scope.init = async function () {
            WdHttpService._remove_wd_session();
            WdHttpService._remove_broker_session();
            $scope.encryptedData = $routeParams.data;
            $scope.salt = $routeParams.iv;
            $scope.random1 = parseInt(Math.random() * 5);
            $scope.random2 = parseInt(Math.random() * 5);
            $scope.pageSections = [true, false, false, false];

            $scope.domain = window.location.host;
        }

        $scope.sendFirstOTP = async function () {
            $scope.showPageLoader();
            await $scope.sendOTP();
            $scope.hidePageLoader();
            $scope.$evalAsync();
        }

        $scope.sendOTP = async function () {
            await WdHttpService._send_otp_for_login($scope.encryptedData, $scope.salt)
                .then(response => {
                    $scope.otpSend = true;
                    $scope.orderId = response.orderId;
                    $scope.clientCode = response.clientCode;
                    $scope.showOTPSubmission();
                    $timeout(function () {
                        $scope.otpSend = false;
                    }, 10 * 1000);
                })
                .catch(error => {
                    console.log(error);
                    $scope.showErrorPopup("Sending OTP failed, Please refresh the page to retry.");
                });
        }

        $scope.resendLoginOTP = async function () {
            $scope.showLoading("#resendLoginOTP");
            $scope.sendOTP();
            $scope.stopLoading("#resendLoginOTP");
        }

        $scope.changePageTo = function (number) {
            if (number >= $scope.pageSections.length) {
                $scope.showErrorPopup('Requested Section was not found');
                return;
            }

            for (let index = 0; index < $scope.pageSections.length; index++) {
                if (index == number) {
                    $scope.pageSections[index] = true;
                } else {
                    $scope.pageSections[index] = false;
                }
            }
            $scope.$evalAsync();
        }

        $scope.showOTPSubmission = function () {
            $scope.changePageTo(1);
        }

        $scope.showUserAgreement = function () {
            $scope.changePageTo(2);
        }

        $scope.showPaymentPage = function () {
            $scope.changePageTo(3);
        }

        $scope.submitOtpLogin = async function (form) {
            $scope.showPageLoader();
            await WdHttpService._post_otp_login(form.otp.$modelValue, $scope.clientCode)
                .then(async response => {
                    await $scope.saveWdSession(response);
                    await $scope.fetchPaymentDetails($scope.orderId);
                }).catch(error => {
                    console.log(error);
                    $scope.showErrorPopup(error);
                });
            $scope.hidePageLoader();
        }

        $scope.saveWdSession = async function (response) {
            sessionService.set("id", JSON.stringify(response.data.authenticationResult.idToken));
            sessionService.set("auth", JSON.stringify(response.data.authenticationResult.accessToken));
            var expireIn = parseInt(response.data.authenticationResult.expiresIn) * 1000 + parseInt(new Date().getTime());
            sessionService.set("expiresIn", expireIn + "");
            sessionService.set("refresh", JSON.stringify(response.data.authenticationResult.refreshToken));
            var cog_profile = await WdHttpService._cognito_profile();
            sessionService.set("brokerName", config.BROKER_WD_NAME);
            sessionService.set("investingMode", "REAL");
            $scope.riskLevel = getProfileValueFor("custom:risk", cog_profile);
            $scope.$evalAsync();
        }

        $scope.fetchPaymentDetails = async function (orderId) {
            await WdHttpService._payment_details({ 'orderId': orderId })
                .then(async (response) => {
                    $scope.paymentDetails = response.data;
                    await $scope.getFundDetails($scope.paymentDetails.fund_name);
                    //User Signs Agreement
                    $scope.isAdviserResearchAnalyst = $scope.fund_details.wealthBasketType == 'RA' ? true : false;
                    let distributorName = $scope.isDistributor ? sessionService.get("distributorName") : $scope.adviserUsername;
                    if (!$scope.isAdviserResearchAnalyst) {
                        $scope.agreementButtonText = 'I Agree to End User Agreement Terms using <br/> OTP based authentication';

                        $scope.userRiskValue = await WdHttpService._get_user_risk_profile(false);
                        $scope.isRiskHigher = $scope.isAdviserResearchAnalyst ? false : isFundRiskHigher($scope.fund_details.risk, $scope.userRiskValue);
                        if ($scope.userRiskValue) {
                            await WdHttpService._get_user_adviser_agreement($scope.fund_details.fundName, $scope.fund_details.adviserUsername, $scope.isAdviserResearchAnalyst, distributorName)
                                .then(response => {
                                    $scope.agreementText = response.agreementCopy;
                                    $scope.showUserAgreement();
                                });
                        }
                    } else {
                        $scope.agreementButtonText = 'I Agree to End User Agreement Terms & Proceed';
                        $scope.analystAgreementStatus = await WdHttpService._get_user_adviser_analyst_agreement_status($scope.fund_details.adviserUsername);
                        if ($scope.analystAgreementStatus != "SIGNED") {
                            await WdHttpService._get_user_adviser_agreement($scope.fund_details.fundName, $scope.fund_details.adviserUsername, $scope.isAdviserResearchAnalyst, distributorName)
                                .then(response => {
                                    $scope.agreementText = response.agreementCopy;
                                    $scope.showUserAgreement();
                                });
                        } else {
                            // Send User to Payment Details Section for Payment
                            await $scope.buildPaymentButtonAndDisplay(response.data);
                        }
                    }
                }).catch(error => {
                    console.log(error);
                    $scope.showErrorPopup('Could not fetch the order details, Please connect with your representative to fix');
                    $scope.hidePageLoader();
                });
        }

        $scope.resendAgreementOtp = async function () {
            $scope.showLoading("#otpResendButton");
            await WdHttpService._post_user_adviser_agreement_initiate($scope.fund_details.fundName, $scope.fund_details.adviserUsername, $scope.mobile, $scope.isAdviserResearchAnalyst)
                .then(response => {
                    $scope.otpErrorMessage = "OTP has been sent again. Kindly wait for 30 sec before you retry.";
                    $scope.showOtpErrorMessage = true;
                    $scope.disableOtpResend = true;
                    $scope.$evalAsync();
                    $timeout(function () {
                        $scope.otpErrorMessage = undefined;
                        $scope.showOtpErrorMessage = false;
                        $scope.disableOtpResend = false;
                        $scope.$evalAsync();
                    }, 30 * 1000);
                }).catch(error => {
                    console.log(error);
                });
            $scope.stopLoading("#otpResendButton");
        }

        $scope.submitOtpField = async function (mobileNumber) {

            $scope.showLoading('#otpSubmitButton');
            $scope.otpErrorMessage = undefined;
            $scope.showOtpErrorMessage = false;
            await WdHttpService._post_user_adviser_agreement_complete_signing($scope.fund_details.fundName, $scope.fund_details.adviserUsername, mobileNumber, $scope.isAdviserResearchAnalyst)
                .then(response => {
                    if (response.status == 'OTP_VERIFIED' || $scope.isAdviserResearchAnalyst) {
                        WdHttpService._post_user_adviser_agreement($scope.fund_details.fundName, $scope.fund_details.adviserUsername, mobileNumber, $scope.agreementText, $scope.isAdviserResearchAnalyst)
                            .then(async response => {

                                if ($scope.isRiskHigher && $scope.isAdviserResearchAnalyst == false) {
                                    WdHttpService._put_risk_profile($scope.fund_details.risk, $scope.fund_details.fundName, $scope.fund_details.adviserUsername, $scope.userRiskValue);
                                }

                                $scope.stopLoading("#agreementSubmitButton");
                                $scope.stopLoading('#otpSubmitButton');
                                $scope.showOTPInput = false;
                                await $scope.buildPaymentButtonAndDisplay($scope.paymentDetails);
                                $scope.$evalAsync();
                            })
                            .catch(error => {
                                console.log(error);
                                $scope.showErrorPopup(error);
                                $('#byFundModal').modal('hide');
                                $scope.stopLoading('#otpSubmitButton');
                                $scope.stopLoading('#agreementSubmitButton');
                            });
                    } else {
                        if ($scope.isAdviserResearchAnalyst == false)
                            $scope.otpErrorMessage = "The OTP you entered is incorrect. Please enter the correct OTP.";
                        else
                            $scope.otpErrorMessage = "Something went wrong. Please try again";
                        $scope.showOtpErrorMessage = true;
                        $scope.stopLoading('#otpSubmitButton');
                        $scope.stopLoading('#agreementSubmitButton');
                        $scope.$evalAsync();
                    }
                }).catch(error => {
                    $('#otpModal').modal('hide');
                    console.log(error);
                    $scope.showErrorPopup(error);
                    $scope.stopLoading('#otpSubmitButton');
                });
        }

        $scope.sendAgreementOtp = async function () {
            $scope.showLoading("#agreementSubmitButton");
            var profileData = await WdHttpService._get_dynamodb_user_profile();
            $scope.mobile = profileData.phoneNumber ? profileData.phoneNumber.replace('+91', '') : undefined;
            await WdHttpService._post_user_adviser_agreement_initiate($scope.fund_details.fundName, $scope.fund_details.adviserUsername, $scope.mobile, $scope.isAdviserResearchAnalyst)
                .catch(error => {
                    console.log(error);
                    $scope.showErrorPopup(error);
                });
            if ($scope.isAdviserResearchAnalyst) {
                $scope.submitOtpField('111111');
            } else {
                $scope.showOTPInput = true;
                $scope.stopLoading("#agreementSubmitButton");
                $scope.$evalAsync();
            }
        }

        $scope.buildPaymentButtonAndDisplay = async function (paymentDetails) {

            // map payment details to UI
            $scope.investmentType = paymentDetails.investment_type;
            $scope.amt = paymentDetails.fee_amount;
            $scope.totalAmt = paymentDetails.txn_amount;
            $scope.gstAmt = paymentDetails.gst_amount;
            $scope.paytm_data = {
                "CUST_ID": paymentDetails.username,
                "MOBILE_NO": paymentDetails.mobile_no,
                "EMAIL": paymentDetails.email,
                "TXN_AMOUNT": paymentDetails.txn_amount,
                "CALLBACK_URL": config.API_ROOT_URL + config.CALLBACK_URL,
                // "CALLBACK_URL": paymentDetails.callback_url,
                "CHANNEL_ID": paymentDetails.CHANNEL_ID,
                "INDUSTRY_TYPE_ID": paymentDetails.INDUSTRY_TYPE_ID,
                "WEBSITE": paymentDetails.WEBSITE,
                "splitSettlementInfo": paymentDetails.splitSettlementInfo,
                "MID": paymentDetails.MID,
                "ORDER_ID": paymentDetails.order_id,
                "CHECKSUMHASH": paymentDetails.signature
            }

            $scope.$evalAsync();

            await analyticsService._push_custom_event_data_to_datalayer('fund-fee-payment', {});

            $scope.showPaymentPage();

        }

        $scope.getFundDetails = async function (fundName) {
            var data = { q: "fundName:" + fundName }
            await WdHttpService._get_funds(data)
                .then(async function (response) {
                    if (response.status == 200) {
                        // This if condition is coded due to a server side bug to be fixed yet.
                        if (response.data.Items.length > 1) {
                            response.data.Items.forEach(fund => {
                                if (fund.fundName == $routeParams.fundname)
                                    $scope.fund_details = fund;
                            });
                        } else
                            $scope.fund_details = response.data.Items[0];

                    }
                }).catch(error => {
                    console.log(error);
                    $scope.showErrorPopup('Loading of WealthBasket detail failed. ' + error);
                    $scope.fund_details = {};
                });
        }

        $scope.signUserAgreement = async function (orderId) {
            await WdHttpService._payment_details({ 'orderId': orderId })
                .then(async (response) => {

                    // await $scope.buildPaymentButtonAndDisplay(response.data);
                }).catch(error => {
                    console.log(error);
                    $scope.showErrorPopup('Could not fetch the order details, Please connect with your representative to fix');
                    $scope.hidePageLoader();
                });
        }

        $scope.redirectToFundDiscovery = async function () {
            $('#byFundModal').modal('hide');
            window.location.href = '/fund-discovery';
        }

        $scope.loginUsingBrokerToken = async function (customAuth = undefined) {
            if (!sessionService.isLoggedIn()) {
                var customAuthData;
                if (customAuth) {
                    customAuthData = customAuth;
                } else {
                    customAuthData = {
                        'username': sessionService.get("cognito_username"),
                        'brokerToken': JSON.stringify(sessionService.get('sessionObject'))
                    };
                }

                await WdHttpService._broker_token_login(customAuthData)
                    .then(async function (response) {
                        await $scope.saveWdSession(response);
                        var orderId = $routeParams.orderId;
                        await $scope.fetchPaymentDetails(orderId);
                    })
                    .catch(function (error) {
                        console.log(error);
                        $scope.showErrorPopup('Some error occured in logging process, please try again later.');
                    });
            }
        }

        $scope.trustAction = function () {
            return $sce.trustAsResourceUrl(config.PAYTM_URL);
        };

        $scope.tempBrokerLoginCode = async function () {
            var clientCode = $routeParams.clientCode;
            var orderId = $routeParams.orderId;
            if (clientCode && orderId) {
                $scope.showPageLoader();
                sessionService.set('offlineOrderId', orderId);
                await $scope.loginUsingBrokerToken(customAuth = {
                    "username": "YESSEC" + clientCode,
                    "brokerToken": "{\"client_id\":\"" + clientCode + "\",\"token_id_2\":\"dfbc121eee68dbeeb65e\",\"iv\":\"7tYQTXRBfSVZcserqNEeTg==\"}"
                });
            }
        }

    }
]);